import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { RootState } from 'store';
import { Scaffold } from 'layouts';
import { FormPageHeader } from 'components/Shared';
import { TypeUpdateForm } from 'components/Pages/CargoTypes';
import * as S from './styles';

export const CargoTypeUpdatePage: React.FC = () => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();

  const { loading } = useSelector((state: RootState) => state.fetchCargoType);

  const onUpdate = useCallback((): void => {
    navigate('/configuracoes/tipos-cargas');
  }, [navigate]);

  return (
    <Scaffold>
      <S.PageContainer>
        <S.MainPanel>
          <FormPageHeader
            title="Editar tipo de carga"
            icon={<S.TruckIcon />}
            isLoading={loading}
            actions={
              <S.LinkButton size="small" to="/configuracoes/tipos-cargas">
                <S.ArrowLeftIcon /> Voltar
              </S.LinkButton>
            }
          />
          <TypeUpdateForm typeId={id} onUpdate={onUpdate} />
        </S.MainPanel>
      </S.PageContainer>
    </Scaffold>
  );
};
